<template>
  <div
    class="progress-container"
    :class="{
      [`progress-${type}`]: type,
      [`progress-${size}`]: size
    }"
  >
    <span :class="big_text?'big-progess-badge':'progress-badge' " v-if="label">{{ label }}</span>
    <div class="progress">
      <span v-if="showValue && valuePosition === 'left'"
            :class="big_text?'big-text-progess':'progress-value'"
        >{{ value }}%</span
      >
      <div
        class="progress-bar"
        :class="computedClasses"
        role="progressbar"
        :aria-valuenow="value"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="`width: ${value}%;`"
      >
        <slot>
          <span
            v-if="showValue && valuePosition === 'right'"
            :class="big_text?'big-text-progess':'progress-value'"
            >{{ value }}%</span
          >
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'base-progress',
  props: {
    striped: Boolean,
    showValue: {
      type: Boolean,
      default: true
    },
    animated: Boolean,
    label: String,
    valuePosition: {
      type: String,
      default: 'left' // left | right
    },
    big_text:{
      type:Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'sm'
    },
    value: {
      type: Number,
      default: 0,
      validator: value => {
        return value >= 0 && value <= 100;
      }
    }
  },
  computed: {
    computedClasses() {
      return [
        { 'progress-bar-striped': this.striped },
        { 'progress-bar-animated': this.animated }
      ];
    }
  }
};
</script>
<style scoped>
.big-text-progess{
  font-size: 20px!important;
  color: #344675;
  position: absolute;
  right: 0;
  top: 12px !important;
  text-align: right;
}
.big-progess-badge{
  font-size: 20px!important;
  top: 10px !important;

  color: #344675;
}
</style>
